import request from "../../../helpers/request";
import { ELevelUser } from "../types";

export const getRegionais = async (idDivisao: string) => {

  try {
    const url = idDivisao
      ? `/Regional/GetRegionaisIdDivisao?idDivisao=${idDivisao}`
      : `/Regional`;
    const result = await request({ url });
    return result;
  } catch (err) {
    throw err;
  }
};
